import { api, BaseAPI } from '@services/api';

class API extends BaseAPI {
  constructor() {
    super('/nnc/actionplan');
  }

  createActionPlan = async (data: object) => {
    return api.post(this.buildUrl('create_action_plan'), data);
  };

  update_action_plan = async (id: number | string, data: object) => {
    return api.put(this.buildUrl(`${id}/update_action_plan`), data);
  };
  tasks = async () => {
    return api.get(this.buildUrl('tasks'));
  };
}

export default new API();
